//#region Imports

/**
To use React related functionality
*/
import React from 'react';
/**
Allows component  to connect the Redux store.
*/
import { connect } from 'react-redux';
/**
It is used to wrap action creators in a dispatch call so that they can be invoked directly from a component.
*/
import { bindActionCreators } from 'redux';
/**
To use location input component
*/
import LocationInput from './LocationInput';
/**
To use exchange button component
*/
import ExchangeButton from './ExchangeButton';
/**
To use Planner Options component
*/
import PlannerOptions from './PlannerOptions';
/**
updateFormField : To Update form field
fetchDirections : to get new trip details
*/
import {updateFormField, fetchDirections} from '../../actions';
//#endregion
// Stores all form state in the Planner, responsible for
// controlling all child components, error handling,
// and validation.
// TODO: Ensure form meets all accessibility requirements
class Planner extends React.Component {
    constructor(props) {
        super(props);
        //set default value for showSummary
        this.state = {
            showSummary: false
        };
        //Handle input filed 
        this.handleInput = this.handleInput.bind(this);
    }

    // If there are initial form values,
    // try to fetch directions
    componentDidMount() {
        if (this.props.form.fromPlace.value) {
            //check form field is valid
            const formIsValid = this.validate();
            if (formIsValid) {
                //if it is valid then show summary and fetch new trip details
                this.setState({showSummary: true});
                this.props.fetchDirections(this.props.form);
            }
        }
    }

    // Fields may override default event return,
    // but all must return at minimum something of format
    // target: { name: String, value: Any }
    handleInput(e) {
        this.props.updateFormField(e);
    }

    onFormSubmit(e) {
        e.preventDefault();
        // Validate form here? Add a form error action to keep everything
        // clean and the central data truthy
        const formIsValid = this.validate();
        //check form field is valid
        if (formIsValid) {
            //if it is valid then show summary and fetch new trip details
            this.setState({showSummary: true});
            this.props.fetchDirections(this.props.form);
        } else {
            // dispatch formError()
        }
    }

    validate() {
        // TODO: write form validation
        return true;
    }

    swapLocations() {
        //store form object
        let { form } = this.props;
        //store from place value
        let prevOrigin = form.fromPlace;
        //store from to value
        let prevDestination = form.toPlace;
        //Update From field
        this.props.updateFormField({
            //set name value pair in target object
            target: {
                name: 'fromPlace',
                value: prevDestination.value
            },
            //set displayValue in params 
            params: {
                displayValue: prevDestination.displayValue
            }
        });
        //Update To field
        this.props.updateFormField({
            //set name value pair in target object
            target: {
                name: 'toPlace',
                value: prevOrigin.value
            },
            //set displayValue in params
            params: {
                displayValue: prevOrigin.displayValue
            }
        });
        //set showSummary to true.
        this.setState({showSummary: true});
        //fetch new trip details
        this.props.fetchDirections(this.props.form);
    }

    render() {
        //Save css class
        const plannerClass = this.state.showSummary ? 'otp-planner-form otp-planner-summary' : 'otp-planner-form';
        return (
            <div className={plannerClass}>
                <div className="otp-form-header">
                    <h2>Plan Your Trip</h2>
                </div>
                <form>
                    <div className="otp-planner-body">
                        <LocationInput
                            placeholder="Start"
                            title="From"
                            name="fromPlace"
                            handleChange={this.handleInput}
                            showSummary={this.state.showSummary}
                            {...this.props.form.fromPlace}
                        />
                        <ExchangeButton
                            handleClick={() => this.swapLocations()}
                            showSummary={this.state.showSummary}
                        />
                        <LocationInput
                            placeholder="End"
                            title="To"
                            name="toPlace"
                            handleChange={this.handleInput}
                            showSummary={this.state.showSummary}
                            {...this.props.form.toPlace}
                        />
                        <PlannerOptions
                            form={this.props.form}
                            handleInput={this.handleInput}
                            showSummary={this.state.showSummary}

                        />
                        {!this.state.showSummary &&
                        <div className="otp-form-footer">
                            <div className="otp-form-control">
                                <input
                                    type="checkbox"
                                    checked={this.props.form.useMap.value === 'true'}
                                    name="useMap"
                                    id="useMap"
                                    onChange={this.handleInput}
                                />
                                <label htmlFor="useMap">Show trip on Interactive Map</label>
                            </div>
                            <button type="submit" onClick={e => this.onFormSubmit(e)}>
                                Get Directions
                            </button>
                        </div>
                        }
                        {this.state.showSummary &&
                        <div className="otp-form-footer">
                            <div className="otp-form-control">
                                <input
                                    type="checkbox"
                                    checked={this.props.form.useMap.value === 'true'}
                                    name="useMap"
                                    id="useMap"
                                    onChange={this.handleInput}
                                />
                                <label htmlFor="useMap">Show trip on Interactive Map</label>
                            </div>
                            <div className="otp-button-primary otp-edit-button">
                                <button
                                    onClick={() => this.setState({showSummary: false})}
                                >
                                Edit Trip
                                </button>
                            </div>
                        </div>
                        }
                    </div>
                </form>
            </div>
        );
    }
}
//dispatch actions to the Redux store.
const mapDispatch = dispatch => {
    //wraps two action creators updateFormField and fetchDirections
    return bindActionCreators({updateFormField, fetchDirections}, dispatch);
};

/**
 * 
The function takes the state object as an argument, which represents the current state of the Redux store. 
It then extracts the form property from the state using destructuring.
error: This is mapped to the error property of the form object in the Redux state.
loading: This is mapped to the loading property of the form object in the Redux state.
form: This is mapped to the fields property of the form object in the Redux state.
 */
const mapStateToProps = state => {
    const {form} = state;
    return {
        error: form.error,
        loading: form.loading,
        form: form.fields
    };
};

export default connect(mapStateToProps, mapDispatch)(Planner);
